import React, { useState } from 'react'
import { searchs, admin, videoIcon, group, saved, rating, maths, lock, arrowLeft } from '../../assets'
import AvatarImage from './../../components/avatarImage'
import { fake } from '../../faker'
import { VideoModal } from '../../components/Generic'
import Comments from '../../components/Comments'
import { Link } from 'react-router-dom'

const Search = () => {
  const [active, setActive] = useState('user')
  const [isVidModalOpen, setisVidModalOpen] = useState(false);
  const [isChildValueFalse, setIsChildValueFalse] = useState(false);

  function numberToArray(number) {
    return Array(number).fill().map((_, index) => index);
  }
  const handleChildValueChange = (newValue) => {
    setIsChildValueFalse(newValue);
  };
  const openVidModal = () => {
    setisVidModalOpen(true);
  };
  const closeVidModal = () => {
    setisVidModalOpen(isChildValueFalse);
  };
  const locked=true
  const rate = 5; // Replace this with your constant number
  const resultArray = numberToArray(rate);
  console.log(resultArray);
  return (
    <div className='w-full max-w-[1100px] box-border px-[30px]'>
        <div  className='rounded-[12px]   mt-[50px] items-center flex w-full h-[48px]'>
            <div className='pl-[16px] pr-[12px]'><img className='opacity-40 w-[24px] h-[24px]' src={searchs} alt="" /></div>
            <input className='outline-none border-none sm:text-[18px] text-gray-usersGray bg-inherit w-full' type="text" placeholder='what you want to learn?' />
        </div>
        <div className='flex gap-[20px] mt-[14px]'>
            <div onClick={()=>setActive('user')} className={`flex items-center hover:bg-blue-activeSearchBlue transition-all rounded-[11px] gap-[5px] cursor-pointer py-[5px] px-[20px] ${active==='user' ? 'bg-blue-activeSearchBlue' :' bg-gray-subjectGray'}`}>
                <div><img className='w-[16px] opacity-50 h-[16px] sm:w-[22px] sm:h-[22px]' src={admin} alt="" /></div>
                <div className='text-[14px] sm:text-[18px] text-gray-lessonGray'>User</div>
            </div>
            <div onClick={()=>setActive('video')} className={`flex items-center hover:bg-blue-activeSearchBlue transition-all rounded-[11px] gap-[5px] cursor-pointer py-[5px] px-[20px] ${active==='video' ? 'bg-blue-activeSearchBlue' :' bg-gray-subjectGray'}`}>
                <div><img className='w-[16px] opacity-60 h-[16px] sm:w-[22px] sm:h-[20px]' src={videoIcon} alt="" /></div>
                <div className='text-[14px] sm:text-[18px] text-gray-lessonGray'>Video</div>
            </div>
            <div onClick={()=>setActive('group')} className={`flex items-center hover:bg-blue-activeSearchBlue transition-all rounded-[11px] gap-[5px] cursor-pointer py-[5px] px-[20px] ${active==='group' ? 'bg-blue-activeSearchBlue' :' bg-gray-subjectGray'}`}>
                <div><img className='w-[16px] opacity-60 h-[16px] sm:w-[22px] sm:h-[22px]' src={group} alt="" /></div>
                <div className='text-[14px] sm:text-[18px] text-gray-lessonGray'>Group</div>
            </div>
        </div>
        {
          active==='user'?
          <div className='mt-[45px] flex gap-[16px] w-full flex-wrap'>
          {fake.map((item)=>(
            
            <Link to='/user' className='flex w-full justify-between max-w-[334px] sm:max-w-[450px] items-center'>
                <div className='flex items-center  gap-[22px]'>
                <div>
                    <AvatarImage style={`w-[40px] h-[40px] sm:w-[100px] sm:h-[100px]`}/>
                </div>
                <div>
                    <div className='flex gap-[9px]'>
                        <div className='w-[160px]  sm:h-[30px] h-[22px] overflow-hidden relative shadow-whiteShadow'>
                        <div className='text-[14px] w-full whitespace-nowrap absolute font-bold sm:text-[18px]'>Jane Cooper</div>
                        </div>
                    </div>
                    <div className='text-[10px] sm:text-[14px] font-[Poppins] text-gray-usersGray'>Username</div>
                </div>
                </div>

                <div className='text-[12px]  sm:text-[16px]   cursor-pointer'></div>
            </Link> 
          ))}
        </div> : active==='video' ?
        <div className='mt-[50px]'>
            <div className='mt-[17px] flex gap-[10px] items-center '>
                <AvatarImage style={`w-[35px] h-[35px] sm:w-[50px] sm:h-[50px]`}/>
                <div className='text-[17px] sm:text-[21px]'>Username</div>
            </div>
        <div className=' mx-[-30px] sm:mx-[0px] flex flex-wrap gap-[20px] overflow-hidden'>
        {
                fake.map((item)=>(
                    <div className='w-full sm:w-[500px]'>
                <div className='h-[270px] flex justify-center relative sm:h-[330px]  overflow-hidden'>
                    {
                        locked &&
                    <Link to='/about' className='absolute flex justify-center items-center w-full sm:w-[500px] overflow-hidden top-0 left-0 h-[300px]'>
                    <div className='absolute w-full sm:w-[500px] z-[5] top-0 left-0 h-[220px] sm:h-[330px] bg-gray-opacityGray opacity-40'></div>
                    <div className='z-[10] flex justify-center flex-col gap-[17px] items-center relative'>
                        <div><img src={lock} alt="" /></div>
                        <div className='text-[Poppins] cursor-pointer text-[12px] bg-blue-buttonBlue px-[15px] py-[5px] rounded-[2px] text-white'>Sotib olish</div>
                    </div>
                    </Link>
                    }
                    <img className='w-full' src={maths} alt="" />
                    <Link to='/about' className='bg-blue-lessonBlue z-[7] absolute rounded-[8px] text-white px-[42px] cursor-pointer text-[Poppins] flex justify-center w-[195px] whitespace-nowrap  py-[10px] font-[500] bottom-[10px] text-[18px]'>Matematika</Link>
                </div>
                <div className='text-blue-darkBlue text-[16px] mt-[-10px] sm:text-[20px] font-[500] pl-[22px]'>Matematika bo’yicha video Kurs(lar)</div>
                <div className='flex justify-between mx-[20px]'>
                    <div className='flex gap-[3px] mt-[10px]'>
                    {
                        resultArray.map((item)=>(
                            <img src={rating} key={item.index} alt="" />
                        ))}
                    </div>
                    <div><img src={saved} alt="" /></div>
                </div>
                <div onClick={openVidModal} className='text-gray-opacityGray text-[14px] mt-[13px] ml-[20px] cursor-pointer sm:text-[18px]'>View all 50 comments</div>
                <div onClick={openVidModal} className='border-solid text-gray-opacityGray shadow-commentShadow sm:text-[18px] cursor-pointer border-[0.5px] border-gray-inputGray px-[20px] mt-[8px] py-[10px]'>Add comment...</div>
            </div>
                ))}
            </div>
            <VideoModal style={`${true}`}  onClose={closeVidModal} comments={true}  isOpen={isVidModalOpen}>
                            <div className='flex justify-between items-center mt-[40px] ml-[40px]'>
                                <div className='z-50 relative' onClick={closeVidModal}><img src={arrowLeft} alt="" /></div>
                                <div className='text-[20px] font-medium'>Comments</div>
                                <div className='w-[50px]'></div>
                            </div>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                </VideoModal>
    </div> 
    : active==='group' ?
  <h2 className='text-gray-darkGray text-[22px] opacity-40 mt-[40px]'>Groups are not available now</h2> :
  null
  }
    </div>
  )
}

export default Search